import { Pipe, PipeTransform, Injectable } from '@angular/core';
@Pipe({
    name: 'filterResults'
})
@Injectable()
export class FilterPipe implements PipeTransform {
    transform(items: any[], field : string, value : string): any[] { 
      if (!items) return [];

      if (!value || value.length == 0) return items;

      var results = items.filter(it => 
      it[field].toString().toLowerCase().indexOf(value.toLowerCase()) !=-1);
      return results;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/filter.pipe.ts